import { render, staticRenderFns } from "./StockchartMenuSecundario.vue?vue&type=template&id=00d8adae&scoped=true&"
import script from "./StockchartMenuSecundario.vue?vue&type=script&lang=js&"
export * from "./StockchartMenuSecundario.vue?vue&type=script&lang=js&"
import style0 from "./StockchartMenuSecundario.vue?vue&type=style&index=0&id=00d8adae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d8adae",
  null
  
)

export default component.exports